import { render, staticRenderFns } from "./MultiClickAndCollectLinks.vue?vue&type=template&id=94dd45d2&scoped=true"
import script from "./MultiClickAndCollectLinks.vue?vue&type=script&lang=ts"
export * from "./MultiClickAndCollectLinks.vue?vue&type=script&lang=ts"
import style0 from "./MultiClickAndCollectLinks.vue?vue&type=style&index=0&id=94dd45d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94dd45d2",
  null
  
)

export default component.exports